<template functional>
  <router-link
    :to="{
      name: props.type === 'learning-path' ? 'playlist' : 'course',
      params: { id: props.course.id, slug: props.course.slug },
    }"
    class="list-result-style"
  >
    <div class="list-result-style__tile-img">
      <img :src="props.tileImg" onerror="this.style.display='none'" />
    </div>
    <div class="list-result-style__title">{{ props.course.title }}</div>
    <div class="list-result-style__duration">{{ props.duration }}</div>
    <div class="list-result-style__difficulty">
      <component
        :is="injections.components.DifficultyComponent"
        :difficulty="props.difficulty || null"
      ></component>
    </div>
  </router-link>
</template>

<script>
import DifficultyComponent from '../../layout/DifficultyComponent.vue'

export default {
  name: 'ListResult',
  inject: {
    components: {
      type: Object,
      default() {
        return {
          DifficultyComponent,
        }
      },
    },
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    course: {
      type: Object,
      required: false,
    },
    tileImg: {
      type: String,
      required: false,
    },
    duration: {
      type: String,
      required: true,
    },
    difficulty: {
      type: Number,
      required: false,
    },
  },
}
</script>

<style lang="scss">
.list-result-style {
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  @include mobile {
    flex-wrap: nowrap;
  }
  &:hover {
    opacity: 0.7;
  }
  &__tile-img {
    width: 20%;
    & img {
      background: linear-gradient(
        to left bottom,
        rgb(239, 125, 34),
        rgb(249, 170, 13)
      );
      width: 80px;
      height: 50px;
    }
  }
  &__title {
    width: 50%;
    color: var(--white);
    font-size: 1rem;
    margin: 0 auto 0 20px;
  }
  &__duration {
    width: 10%;
    color: var(--white);
  }
  &__difficulty {
    width: 20%;
    margin: 0 0 0 10px;
    @include mobile {
      margin: 0 0 0 auto;
    }
  }
}
</style>
